/* eslint-disable no-unused-vars */
/* eslint-disable consistent-return */
const throttled = {};
export default store => next => (action) => {
    const time = action.meta && action.meta.throttle;
    if (!time) { return next(action); }
    if (throttled[action.type]) {
        clearTimeout(throttled[action.type]);
    }
    throttled[action.type] = setTimeout(() => {
        next(action);
    }, time);
};
